import React from 'react';
import { Form } from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import { FaPhone } from 'react-icons/fa';
import "react-phone-input-2/lib/style.css";

const PhoneNumberField = React.memo(({
    label = "Phone Number",
    value,
    onChange,
    error,
    required = false
}) => {
    const handleChange = (fullValue, countryData) => {
        const countryCode = `+${countryData.dialCode}`;
        const phoneNumber = fullValue.replace(/\D/g, "");
        
        onChange({
            countryCode,
            phoneNumber,
        });
    };

    return (
        <Form.Group className="mb-4">
            <div className="input-wrapper">
                <PhoneInput
                    country={value.countryCode || "us"}
                    value={value.phoneNumber}
                    onChange={handleChange}
                    enableSearch={true}
                    inputStyle={{
                        width: "100%",
                        height: "52px",
                        borderRadius: "50px",
                        border: error ? "1px solid #FF3B30" : "1px solid #E5E7EB",
                        backgroundColor: "#F5F5F7",
                        fontSize: "16px",
                        paddingLeft: "52px",
                        paddingRight: "50px"
                    }}
                    buttonStyle={{
                        border: "none",
                        backgroundColor: "transparent",
                        borderRadius: "12px 0 0 12px"
                    }}
                    containerStyle={{
                        borderRadius: "12px"
                    }}
                />
                {/* Phone icon on RIGHT */}
                <div className="input-icon" style={{ pointerEvents: 'none' }}>
                    <FaPhone size={16} />
                </div>
            </div>
            {error && (
                <span style={{
                    fontSize: "0.875rem",
                    color: "#FF3B30",
                    marginTop: "4px",
                    display: "block"
                }}>
                    {error}
                </span>
            )}
        </Form.Group>
    );
});

export { PhoneNumberField };